import { useEffect, useRef } from 'react'
import { Button } from '../../../components/ui'

export default function UnsavedReportChangesModal({ saving, error, onSave, onStay, onLeave }) {
  const dialog = useRef(null)
  useEffect(() => { dialog.current?.focus() }, [])

  const onKeyDown = (event) => {
    if (event.key === 'Escape') { event.preventDefault(); onStay() }
    if (event.key !== 'Tab') return
    const buttons = [...dialog.current.querySelectorAll('button:not(:disabled)')]
    const first = buttons[0]
    const last = buttons[buttons.length - 1]
    if (!first) { event.preventDefault(); return }
    if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog.current)) {
      event.preventDefault(); last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus()
    }
  }

  return (
    <div className="modal-overlay" onClick={onStay}>
      <div className="modal-content" ref={dialog} tabIndex={-1} role="dialog" aria-modal="true"
        aria-labelledby="unsaved-report-title" aria-describedby="unsaved-report-description"
        onClick={event => event.stopPropagation()} onKeyDown={onKeyDown}>
        <h3 id="unsaved-report-title">Сохранить изменения?</h3>
        <p id="unsaved-report-description">В отчёте есть несохранённые изменения. Сохраните их перед переходом или уйдите без сохранения.</p>
        {error && <div className="message message-error" role="alert">{error}</div>}
        <div className="modal-actions" style={{ flexWrap: 'wrap' }}>
          <Button variant="secondary" onClick={onStay} disabled={saving}>Остаться</Button>
          <Button variant="secondary" onClick={onLeave} disabled={saving}>Уйти без сохранения</Button>
          <Button variant="primary" onClick={onSave} disabled={saving}>{saving ? 'Сохранение…' : 'Сохранить и продолжить'}</Button>
        </div>
      </div>
    </div>
  )
}
